import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/yimo-img/phone.png'
import _imports_1 from '../../assets/img/yimo-img/linkyimo.png'
import _imports_2 from '../../assets/img/yimo-img/des-2.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5f38a372"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "next" }, null, -1))
const _hoisted_2 = { class: "Page-two" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "phone",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "linkyimo",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "linkyimo1",
  src: _imports_2,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["box2 animate__faster", {
        animate__animated: _ctx.nowPage === 1,
        animate__fadeInLeft: _ctx.nowPage === 1
      }])
      }, _hoisted_4, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["box3 animate__faster", {
        animate__animated: _ctx.nowPage === 1,
        animate__fadeInRight: _ctx.nowPage === 1
      }])
      }, [
        _hoisted_5,
        _createElementVNode("div", {
          class: _normalizeClass(["pageOneWord animate_fast", {
          animate__animated: _ctx.nowPage === 1,
          animate__fadeInRight: _ctx.nowPage === 1
        }])
        }, [
          _createTextVNode(" 与职业选手组局，上分更容易"),
          _hoisted_6,
          _createTextVNode(" 专业的竞技赛事玩法让你体会到不一样的乐趣！ ")
        ], 2),
        _hoisted_7
      ], 2)
    ])
  ], 64))
}